import { Component, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Message, FileUpload } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '../../../service/account/account.service';
import { UploadFilesService } from '../../../service/upload-files/upload-files.service';
import { PagesComponent } from '../../pages.component';
import { config } from '../../../../../../environments/config';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { User } from '../../../class/user';
import { Employee } from '../../../class/employee';
import { formatDate } from '../../../../../theme/functions/formatDate.function';



@Component({
  selector: 'app-account-edit-component',
  templateUrl: './account-edit-component.component.html',
  styleUrls: ['./account-edit-component.component.scss']
})
export class AccountEditComponentComponent implements OnInit {
    public user: User;
    public edit = false;
    public editPass = false;
    public userEdit: User;
    public form: FormGroup;
    public formPassword: FormGroup;
    public email: AbstractControl;
    public language: AbstractControl;
    public current_password: AbstractControl;
    public password: AbstractControl;
    public confirmPassword: AbstractControl;
    public msgs: Message[] = [];
    public apiUrl = config.API_ROOT;
    public uploadedAvatar: any[] = [];
    public prewiewAvatar: any;
    public defaultAvatar: any;
    public avatar: any;
    public promiseSubmit: Promise<any>;
    public promiseAvatar: Promise<any>;
    public promisePass: Promise<any>;
    public langs= [
            {
                label: 'English', abr: 'en',
            },
            {
                label: 'Español', abr: 'es',
            },
        ];

    public employee: Employee;
    public fieldTextType: Boolean= false;
    public fieldTextType2: Boolean= false;
    public fieldTextType3: Boolean= false;
  constructor(
    fb: FormBuilder,
    public accountService: AccountService,
    public uploadFilesService: UploadFilesService,
    public translate: TranslateService,
    public pagesComponent: PagesComponent,
    private _router: Router,
    private route: ActivatedRoute
  ) {
    this.form = fb.group({
      'name': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
      'email': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
      'language': [],
    });

    this.formPassword = fb.group({
          'current_password': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
          'password': ['', Validators.compose([Validators.required, Validators.minLength(6),Validators.pattern("^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9.*]+$")])],
          'confirmPassword': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      });
      this.email = this.form.controls['email'];
      this.language = this.form.controls['language'];

      this.current_password = this.formPassword.controls['current_password'];
      this.password = this.formPassword.controls['password'];
      this.confirmPassword = this.formPassword.controls['confirmPassword'];

      this.defaultAvatar = require('../../../../../../assets/images/Luciana.png');
      this.getProfile();
      this.getProfilePermissions();
  }

  ngOnInit() {
  }

  public onUpload(event: any) {
    this.uploadedAvatar = [];
    for (const file of event.srcElement.files) {
        this.uploadedAvatar.push(file);
    }
    if (event.target.files && event.target.files[0]) {
        const reader = new FileReader();
        reader.onload = () => {
          this.prewiewAvatar = reader.result;
        };
        reader.readAsDataURL(event.target.files[0]);
    }
  }
  public updateProfile(values) {
    event.preventDefault();
    this.promiseSubmit = this.accountService.updateProfile(values).toPromise().then(
        response => {
            this.translate.get('saved').subscribe((res: string) => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: res  } );
            });
            this.getProfile();
            // this.pagesComponent.getAccount();
        },
        error => {
            let errorMsg = '';
            errorMsg = 'Error';
            this.msgs = [];
            this.msgs.push( { severity: 'error', summary: errorMsg  } );
        }
    );

    this.updatePassword(values);
  }

  public updatePassword(values) {
    event.preventDefault();

    const d = new Date();
    const body = {
      'current_password': values.current_password,
      'new_password': values.password,
      'password_change_at': d
    };
    this.promisePass = this.accountService.updatePassword(body).toPromise().then(
        response => {
            this.translate.get('saved').subscribe((res: string) => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: res  } );
            });
            let profileLocalStorage = JSON.parse(localStorage.getItem('profile'));
            profileLocalStorage.password_change_at = formatDate(body.password_change_at);
            localStorage.removeItem('profile');
            localStorage.setItem('profile', JSON.stringify(profileLocalStorage));
            alert("Contraseña actualizada exitosamente!");
            this.closeEditPass();
        },
        error => {
            let errorMsg = '';
            if ( error.status === 422  ) {
                this.translate.get('current password invalid').subscribe((res: string) => {
                    errorMsg = res;
                });
            }
            if ( error.status === 500 ) {
                 errorMsg = 'Error';
            }
            this.msgs = [];
            this.msgs.push( { severity: 'error', summary: errorMsg  } );
        }
    );
  }

  public closeEditPass() {
    console.log('cancelEmployee');
    this.password.setValue('');
    this.current_password.setValue('');
    this.confirmPassword.setValue('');
    this.editPass = false;
    this._router.navigate(['pages/account']);
  }
  public getProfile() {
    this.accountService.getAccount().toPromise().then(
        response => {
            this.user = response.json();
            this.employee = this.user.employee;
            this.avatar = (this.user.avatar) ? this.user.avatar : this.defaultAvatar;
            this.edit = true;
            this.email.setValue(this.user.email);
            this.language.setValue(this.user.language);
            this.userEdit = this.user;
            this.avatar = (this.user.avatar) ? this.user.avatar : this.defaultAvatar;
            // this.getAvatar();
        },
        error => {
            console.log(error.json());
        }
    );
  }

  public getProfilePermissions() {
    this.accountService.getAccountPermissions().toPromise().then(
        response => {
            this.user.permissions = response.json();
        },
        error => {
            console.log(error.json());
        }
    );
  }
  public cancelEmployee() {
    // this.edit = false
    this._router.navigate(['pages/account']);
    this.getProfile();
}
  public checkPass(values){
    if(values.password != values.confirmPassword)
      return false;
    if(values.password == values.current_password )
      return false;
    return true;
  }
  toggleFieldTextType(field_password: number)
  {
    if(field_password==1)
      this.fieldTextType = !this.fieldTextType;
    else if(field_password==2)
    this.fieldTextType2 = !this.fieldTextType2;
    else if(field_password==3)
      this.fieldTextType3 = !this.fieldTextType3;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/account/account-edit-component/account-edit-component.component.ts